angular.module('app.controllers').controller('AttachmentsCtrl', () => {});
